import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import StoreProvider from "store/StoreProvider";
import { NextUIProvider } from "@nextui-org/react";
import { GoogleOAuthProvider } from "@react-oauth/google";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
root.render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <React.StrictMode>
      <StoreProvider>
        <NextUIProvider>
          <App />
        </NextUIProvider>
      </StoreProvider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
